/** Shared JPEG/PNG rules for Org / Property / Unit / Service Request image uploads. */
export const JPEG_PNG_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
] as const;

export const JPEG_PNG_EXTENSIONS = [".jpg", ".jpeg", ".png"] as const;

export const JPEG_PNG_EXTENSION_ERROR =
  "Only JPEG and PNG images are allowed (.jpg, .jpeg, .png).";

export const getFileExtension = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex >= 0 ? fileName.slice(dotIndex).toLowerCase() : "";
};
